var _defs, _g, _g2, _path, _g3, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 62 62",
    width: 178,
    height: 53,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        fill-rule: evenodd;      }      .cls-1, .cls-2 {        fill: #6D6767;        stroke-width: 0px;      }    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.61,2.98l-19.58,31.97h3.7L41.31,2.98h-3.7ZM21.26,34.37h-2.06L38.12,3.58h2.06l-18.91,30.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.73,2.98l-19.56,31.97h3.7L48.45,2.98h-3.72ZM28.38,34.37h-2.06L45.24,3.58h2.06l-18.91,30.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.85,2.98l-19.58,31.97h3.7L55.55,2.98h-3.7ZM35.51,34.37h-2.06L52.36,3.58h2.06l-18.91,30.8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.14,5.47v-1.94h-.69v-.39h1.85v.39h-.69v1.94h-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.78,5.47v-2.34h.69l.42,1.6.42-1.6h.69v2.34h-.44v-1.83l-.46,1.83h-.46l-.46-1.83v1.83h-.39Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.48,33.45l.18.3c1.97,3.03,3.12,5.13,3.81,7.42.95,2.57.92,4.81-.37,6.24-4.07,4.62-19.33,1.43-33.75-7.28C6.84,31.37-.61,20.34,4.02,16.6c1.78-1.43,3.84-2.31,8.69-2.43,1.27-.02,4.88-.12,6.4.39-7.58-2.57-15.19-2.22-17.8.6-4.86,5.29,4.21,17.71,19.98,26.82,15.54,8.97,31.72,12.3,36.3,7.1,2.82-3.21.25-9.99-6.1-15.63ZM57.14,48.96c-4.6,4.83-20.62,1.55-36.07-7.47C5.75,32.57-2.85,20.43,1.54,15.67c2.66-2.87,7.95-3.05,15.56-1.6-2.1-.39-5.32-.09-6.45-.02-4.74.28-6.1,1.06-7.56,2.89-3.51,4.49,3.72,15.05,18.22,23.58,14.47,8.53,30.06,11.81,34.15,7.47,1.32-1.39,1.55-4.12.6-6.66-.72-2.27-1.87-4.09-3.95-7.12,5.5,6.13,7.91,11.74,5.04,14.75Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.02,47.32c-.55,0-1.02.44-1.02,1.02s.46,1.02,1.02,1.02,1.02-.44,1.02-1.02-.46-1.02-1.02-1.02h0ZM4.76,51.41h-1.48v7.65h1.48v-7.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.26,51.41h-1.48v7.65h1.48v-3.51c0-1.39,0-3.05,1.9-3.05,1.5,0,1.66.88,1.66,2.2v4.39h1.48v-4.58c0-1.85-.55-3.33-2.7-3.33-.92,0-1.85.44-2.31,1.25h-.02v-1.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.82,44.87c-.32-.12-.67-.21-1.02-.21-1.9,0-2.47,1.34-2.47,3.03v3.72h-.67v1.39h.67v6.29h1.48v-6.29h2.03v-1.39h-2.03v-3.28c0-.76,0-2.08,1.06-2.08.3,0,.67.18.97.3v-1.48h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.3,47.32c-.55,0-1.02.44-1.02,1.02s.44,1.02,1.02,1.02,1.02-.44,1.02-1.02-.46-1.02-1.02-1.02h0ZM24.04,51.41h-1.48v7.65h1.48v-7.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.55,51.41h-1.48v7.65h1.48v-3.51c0-1.39,0-3.05,1.9-3.05,1.5,0,1.69.88,1.69,2.2v4.39h1.48v-4.58c0-1.85-.55-3.33-2.7-3.33-.95,0-1.85.44-2.31,1.25h-.02v-1.02h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.38,47.32c-.55,0-1.02.44-1.02,1.02s.44,1.02,1.02,1.02,1.02-.44,1.02-1.02c0-.55-.46-1.02-1.02-1.02h0ZM38.12,51.41h-1.48v7.65h1.48v-7.65h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.86 52.8 44.29 52.8 44.29 51.41 42.86 51.41 42.86 48.5 41.4 48.5 41.4 51.41 40.59 51.41 40.59 52.8 41.4 52.8 41.4 59.09 42.86 59.09 42.86 52.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.76,54.37c.16-1.11,1.02-1.9,2.17-1.9s1.92.76,2.1,1.9h-4.28ZM52.5,55.51v-.23c0-2.29-1.16-4.07-3.58-4.07s-3.72,1.76-3.72,4.12,1.43,4.02,3.77,4.02c1.48,0,2.82-.79,3.54-2.1l-1.25-.72c-.55.92-1.16,1.48-2.29,1.48-1.41,0-2.29-1.23-2.31-2.52h5.85v.02Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.29,41.98c-4.81-2.77-8.99-5.87-12.37-8.97l-6.89,11.03h23.05c-1.25-.65-2.52-1.34-3.79-2.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.36,40.13c2.43,1.46,4.88,2.77,7.31,3.91h24.78l-11.63-18.66-5.85,9.55h-3.7l7.68-12.53-1.73-2.77-9.36,15.31h-3.7l11.21-18.31-1.73-2.77-12.9,21.08h-3.7l14.73-24.07-5.02-8.07L9.89,31.44c3.03,2.96,6.89,5.94,11.47,8.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.8323bb1b377b43230ab0c6308497dc4b.svg";
export { ForwardRef as ReactComponent };